import { render, staticRenderFns } from "./ProductTermDropdown.vue?vue&type=template&id=3c44a8ad&scoped=true&"
import script from "./ProductTermDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductTermDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c44a8ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
